import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { ArtistDetails } from '~/modules/artist-roster/types';
import { BREADCRUMBS_PROPS } from '~/modules/constants';
import { Breadcrumbs } from '~/modules/navigation/components/Breadcrumbs';

interface ArtistBreadcrumbsProps {
  artistData?: ArtistDetails;
}

/**
 * This component is wrapped in React.memo() to prevent unnecessary re-renders with
 * the ScrollCollapse logic. See https://github.com/wmgtech/wmg2-one-app/pull/1747
 */
export const ArtistBreadcrumbs: React.FC<ArtistBreadcrumbsProps> = memo(
  ({ artistData }) => {
    const { t } = useTranslation('roster');

    return (
      <Breadcrumbs.Root {...BREADCRUMBS_PROPS.ROOT}>
        <Breadcrumbs.Item to="/roster" {...BREADCRUMBS_PROPS.ITEM_LINK}>
          {t('header.heading')}
        </Breadcrumbs.Item>
        <Breadcrumbs.Item>{artistData?.name}</Breadcrumbs.Item>
      </Breadcrumbs.Root>
    );
  },
);

ArtistBreadcrumbs.displayName = 'ArtistBreadcrumbs';
